import apiV2 from '../api/v2';

// Access > Teams ("teams" is the product name for roles). Generic rather than under
// components/access because the assignee pickers read it too, via hooks/useRoles.ts.

export type RoleScope = 'odo' | 'practice';

export interface Role {
    id: string;
    name: string;
    scope: RoleScope;
    createdAt: string;
}

export interface RoleMember {
    id: string;
    email: string;
    fullname: string;
}

export interface CreateRoleInput {
    name: string;
    scope: RoleScope;
}

export interface UpdateRoleInput {
    name: string;
}

interface Envelope<T> {
    success: true;
    data: T;
}

export const fetchRoles = async (scope?: RoleScope): Promise<Role[]> => {
    const response = await apiV2.get<Envelope<Role[]>>('/roles', {
        params: scope ? { scope } : {}
    });
    return response.data.data;
};

export const fetchRoleMembers = async (roleId: string): Promise<RoleMember[]> => {
    const response = await apiV2.get<Envelope<RoleMember[]>>(`/roles/${roleId}/users`);
    return response.data.data;
};

export const createRole = async (input: CreateRoleInput): Promise<Role> => {
    const response = await apiV2.post<Envelope<Role>>('/roles', input);
    return response.data.data;
};

export const updateRole = async (roleId: string, input: UpdateRoleInput): Promise<Role> => {
    const response = await apiV2.put<Envelope<Role>>(`/roles/${roleId}`, input);
    return response.data.data;
};

export const deleteRole = async (roleId: string): Promise<void> => {
    await apiV2.delete(`/roles/${roleId}`);
};

export const addRoleMember = async (roleId: string, userId: string): Promise<void> => {
    await apiV2.post(`/roles/${roleId}/users`, { userId });
};

export const removeRoleMember = async (roleId: string, userId: string): Promise<void> => {
    await apiV2.delete(`/roles/${roleId}/users/${userId}`);
};
